<template>
  <v-container flex grid-list-lg>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Negociações</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-slide-x-transition>
            <v-layout justify-end v-show="searchingNegociacao">
              <v-flex xs3>
                <v-select
                  outline
                  hide-details
                  single-line
                  placeholder="Filtrar por"
                  :items="filtrosNegociacao"
                  item-value="value"
                  item-text="text"
                  v-model="filtro"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  outline
                  hide-details
                  single-line
                  placeholder="Insira as informações"
                  :mask="filtro === 'cnpj' ? '##.###.###/#####-##' : ''"
                  v-model="campoPesquisa"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-slide-x-transition>
          <v-btn icon color="info" @click="searchingNegociacao = !searchingNegociacao">
            <v-icon v-if="!searchingNegociacao">search</v-icon>
            <v-icon v-else>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="negociacoesHeaders"
          :items="negociacoes"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItems"
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="headerCell" slot-scope="{ header }">
            <span class="font-weight-light" v-text="header.text" />
          </template>
          <template slot="items" slot-scope="props">
            <td>
                <v-icon color="info">work</v-icon>
            </td>
            <td>{{ props.item.identificacao }}</td>
            <td class="text-xs-left">{{ props.item.empresa.nome_fantasia }}</td>
            <td class="text-xs-left">{{ props.item.empresa.cnpj }}</td>
            <td
              class="text-xs-left"
              v-html="`${props.item.desconto ? `${props.item.desconto}%` : ``}`"
            ></td>
            <td class="text-xs-left">
              <v-layout row>
                <v-icon :color="props.item.status ? 'success' :  props.item.status == null ? 'info' : 'error'">
                  {{ props.item.status ? 'check_circle' : props.item.status == null ? 'timer' : 'cancel'}}
                  </v-icon>
                <h4
                  :class="props.item.status ? 'success--text' : props.item.status == null ? 'info--text' : 'error--text'"
                >
                  {{ props.item.status ? 'ACEITA' : props.item.status == null ? 'Aguardando resposta' : 'NÃO ACEITA' }}
                </h4>
              </v-layout>
            </td>
            <td class="text-xs-right">
              <v-tooltip lazy bottom>
                <v-btn icon color="info" slot="activator" flat @click="abrirDetalhes(props.item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>Visualizar Proposta
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
    <v-dialog width="50em" v-model="dialogDetalhes" v-if="dialogDetalhes" scrollable>
      <dialog-detalhes-proposta @error="showError" @success="showSuccess" :proposta="propostaSelecionada" @fechar="dialogDetalhes = false" @carregar="pegarNegociacoes"/>
    </v-dialog>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DialogDetalhesProposta from '@/components/dialogs/DetalhesProposta'
export default {
    components: { SmartLockMessage, DialogDetalhesProposta },
    data: () => ({
        campoPesquisa: '',
        filtro: '',
        searchingNegociacao: false,
        filtrosNegociacao: [
          { value: 'id', text: 'Identificação' },
          { value: 'cnpj', text: 'CNPJ' },
          { value: 'nome_fantasia', text: 'Nome Fantasia' }
        ],
        dialogDetalhes: false,
        propostaSelecionada: undefined,
        snackbar: {
            active: false,
            color: '',
            multiLine: true,
            timeout: 4000,
            vertical: true,
            text: ''
        },
        pagination: {
            rowsPerPage: 5,
            page: 1
        },
        negociacoes: [],
        negociacoesHeaders: [
          {
            sortable: false,
            align: 'right'
          },
          { text: 'Identificacao', sortable: false },
          {
            text: 'Nome Fantasia',
            align: 'left',
            sortable: false,
            value: 'nome_fantasia'
          },
          { text: 'CNPJ', sortable: false, value: 'cnpj' },
          { text: 'Desconto', sortable: false },
          { text: 'Status', sortable: false, value: 'ativo' },
          {
            sortable: false,
            align: 'right'
          }
        ],
        totalItems: 0
    }),
    computed: {
        smartLock () {
            return this.$store.getters.smartLock
        },
        loading () {
            return this.$store.getters.loading
        },
        headers () {
            return this.$store.getters.headers
        },
        pages () {
            if (this.pagination.rowsPerPage == null || this.totalItems == null) {
                return 0
            }

            return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
        },
        searchData () {
          let tempData = {
            page: this.pagination.page,
            has_pagination: true
          }
          if (this.campoPesquisa) {
            switch (this.filtro) {
              case 'id':
                tempData['id__icontains'] = this.campoPesquisa
                break
              case 'nome_fantasia':
                tempData['empresa__nome_fantasia__icontains'] = this.campoPesquisa
                break
              case 'cnpj':
                tempData['empresa__cnpj__icontains'] = this.campoPesquisa
                break
            }
          }
          return tempData
    }
  },
  beforeMount () {
    if (this.headers) {
      this.pegarNegociacoes()
    }
  },
  watch: {
    headers (val) {
      if (val) this.pegarNegociacoes()
    },
    campoPesquisa () {
      this.pegarNegociacoes()
    },
    pagination: {
      handler (val) {
        this.pegarNegociacoes()
      },
      deep: true
    }
  },
  methods: {
      pegarNegociacoes () {
        //  Proposta e negociação são a mesma entidade
        this.$store.dispatch('propostasApetrus', { method: 'GET', filtro: this.searchData }).then(json => {
          this.totalItems = json.count
          this.negociacoes = json.results
        })
      },
      abrirDetalhes (proposta) {
        this.propostaSelecionada = proposta
        this.dialogDetalhes = true
      },
      showSuccess (info) {
        this.snackbar.color = 'primary'
        this.snackbar.text = info
        this.snackbar.active = true
      },
      showError (error) {
        this.snackbar.color = 'error'
        this.snackbar.text = error
        this.snackbar.active = true
      }
  }
}
</script>
